const BLOCK_SELECTOR = '.wp-block-fc-block-fc-columns.has-custom-breakpoint';
const STACK_CLASS = 'fc-columns-force-stack';
const RESPONSIVE_CLASS_PREFIX = 'fc-columns-responsive-cols-';

function getLegacyBreakpoints(block) {
	const breakpoint = parseInt(block.getAttribute('data-fc-breakpoint') || '', 10);

	if (!Number.isFinite(breakpoint) || breakpoint <= 0) {
		return {};
	}

	return { 1: breakpoint };
}

function getResponsiveBreakpoints(block) {
	const rawBreakpoints = block.getAttribute('data-fc-responsive-breakpoints');

	if (!rawBreakpoints) {
		return getLegacyBreakpoints(block);
	}

	try {
		const parsedBreakpoints = JSON.parse(rawBreakpoints);

		if (!parsedBreakpoints || typeof parsedBreakpoints !== 'object') {
			return getLegacyBreakpoints(block);
		}

		return parsedBreakpoints;
	} catch (error) {
		return getLegacyBreakpoints(block);
	}
}

function getActiveResponsiveColumns(width, breakpoints) {
	const entries = Object.entries(breakpoints)
		.map(([columnsPerRow, breakpoint]) => ({
			columnsPerRow: Number(columnsPerRow),
			breakpoint: Number(breakpoint),
		}))
		.filter(
			({ columnsPerRow, breakpoint }) =>
				Number.isFinite(columnsPerRow) &&
				Number.isFinite(breakpoint) &&
				breakpoint > 0
		)
		.sort((a, b) => b.breakpoint - a.breakpoint);

	let activeColumns = null;

	entries.forEach(({ columnsPerRow, breakpoint }) => {
		if (width <= breakpoint) {
			activeColumns = columnsPerRow;
		}
	});

	return activeColumns;
}

function clearResponsiveClasses(block) {
	Array.from(block.classList).forEach((className) => {
		if (className.indexOf(RESPONSIVE_CLASS_PREFIX) === 0) {
			block.classList.remove(className);
		}
	});
}

function setupCustomBreakpoint(block) {
	const breakpoints = getResponsiveBreakpoints(block);

	if (!Object.keys(breakpoints).length) {
		return null;
	}

	const update = () => {
		const viewportWidth =
			window.innerWidth || document.documentElement.clientWidth || 0;
		const activeColumns = getActiveResponsiveColumns(viewportWidth, breakpoints);

		clearResponsiveClasses(block);
		block.classList.toggle(STACK_CLASS, activeColumns === 1);

		if (activeColumns) {
			block.classList.add(`${RESPONSIVE_CLASS_PREFIX}${activeColumns}`);
		}
	};

	update();

	if (typeof ResizeObserver === 'undefined') {
		window.addEventListener('resize', update);
		window.addEventListener('orientationchange', update);

		return () => {
			window.removeEventListener('resize', update);
			window.removeEventListener('orientationchange', update);
		};
	}

	window.addEventListener('resize', update);
	window.addEventListener('orientationchange', update);

	return () => {
		window.removeEventListener('resize', update);
		window.removeEventListener('orientationchange', update);
	};
}

function initCustomBreakpoints() {
	// Guard against running window resize calculations and listeners inside the CMS block editor
	if (
		(document.body && document.body.classList.contains('wp-admin')) ||
		typeof window.wp?.blockEditor !== 'undefined' ||
		document.querySelector('.editor-styles-wrapper')
	) {
		return;
	}

	const blocks = Array.from(document.querySelectorAll(BLOCK_SELECTOR));
	if (!blocks.length) {
		return;
	}

	blocks
		.map((block) => setupCustomBreakpoint(block))
		.filter(Boolean);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initCustomBreakpoints);
} else {
	initCustomBreakpoints();
}
